module.exports = __webpack_public_path__ + "5548cbfcd103973c938c754b1421689d.svg";